// Hand the payload to the new UI via the URL fragment. Required because a full-page
// cross-origin redirect destroys this page's JS context, so we cannot call the new
// page's window.setPayload directly. The fragment (never sent to servers / logs) is
// read & stripped on arrival by payment-web-ui's PayloadProvider.
const PASS_PAYLOAD_IN_HASH = true;

/**
 * Builds the URL to redirect a migrated merchant's user to the new payment UI.
 *
 * The new UI receives its payload ({ accessToken, merchant, languageCode, ... })
 * the same way this UI does: injected into `window.payload` / `window.setPayload`
 * by the native mobile WebView. By default the hand-off relies on the WebView
 * re-injecting the payload after this full-page navigation. This helper is the
 * single place to change that hand-off (see PASS_PAYLOAD_IN_HASH above).
 *
 * @param {string} newUiOrigin - origin of the new payment UI (e.g. https://...)
 * @param {object} [payload]   - current payload; used only by the hash fallback
 * @returns {string} the URL to navigate to
 */
function buildNewUiRedirectUrl(newUiOrigin, payload) {
    if (PASS_PAYLOAD_IN_HASH) {
        const fragment = encodeURIComponent(JSON.stringify(payload || {}));

        return `${newUiOrigin}#payload=${fragment}`;
    }

    return newUiOrigin;
}

export default buildNewUiRedirectUrl;
